import { SlimInquiryView } from '@zola/svc-marketplace-ts-types';

import { MappedInquiryView } from '~/types/mappedResponseTypes';
import { InquiryCloseEventEnum } from '~/types/responseTypes';
import { inquiryCloseEventBooleans } from '~/util/inquiryStatusUtils';

import { InquiryUrlStatus, SERVER_STATUS_TO_URL } from './constants';

type VendorInquiryUrlInternalParams = {
  inquiryUuid: string;
  status: InquiryUrlStatus;
  closeEventType: InquiryCloseEventEnum | null;
};
export type VendorInquiryUrlParams =
  | VendorInquiryUrlInternalParams
  | {
      inquiry: MappedInquiryView | SlimInquiryView;
    };

const getVendorInquiryUrlInternal = ({
  status,
  inquiryUuid,
  closeEventType,
}: VendorInquiryUrlInternalParams): string => {
  const { hasExpireCloseEvent } = inquiryCloseEventBooleans(closeEventType);

  // Expired inquiries are shown in the closed tab.
  // Expired inquiries are viewed at /inspire/vendors/leads/expired/:uuid
  // Closed inquiries are viewed at /inspire/vendors/leads/closed/:uuid
  //
  // So for a closed inquiry, if its expired, send them to /inspire/vendors/leads/expire/:uuid
  const statusForUrl = status === 'closed' && hasExpireCloseEvent ? 'expired' : status;

  return `/inspire/vendors/leads/${statusForUrl}/${inquiryUuid}`;
};

/**
 * Gets the entry point / detail view for an inquiry.   Inquiries that are in
 * the ready state for the vendor can also use getVendorInquiryConnectUrl and
 * getVendorInquiryDeclineUrl to get direct links to the connect and decline
 * pages, bypassing the inquiry details page.
 *
 * @param props
 * @returns
 */
export const getVendorInquiryUrl = (props: VendorInquiryUrlParams): string => {
  if ('inquiry' in props) {
    const { inquiry } = props;
    const { status: serverStatus, uuid } = inquiry;
    const status: InquiryUrlStatus | undefined = SERVER_STATUS_TO_URL[serverStatus];

    const closeEventType = 'closeEventType' in inquiry ? inquiry.closeEventType : null;
    return getVendorInquiryUrlInternal({ status, inquiryUuid: uuid, closeEventType });
  }
  return getVendorInquiryUrlInternal(props);
};

export const getVendorInquiryConnectUrl = ({ inquiryUuid }: { inquiryUuid: string }): string => {
  return `/inspire/vendors/connect/${inquiryUuid}`;
};

export const getVendorInquiryDeclineUrl = ({ inquiryUuid }: { inquiryUuid: string }): string => {
  return `/inspire/vendors/decline/${inquiryUuid}`;
};
